module.exports = __webpack_public_path__ + "img/PRCA1_Mono.Macro.00135c90.png";